import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";

import {
  addManufacturerToDb,
  clearAddManufacturer,
} from "../../../redux/slices/Master/Manufacturer/addManufacturerSlice";
import { setShowMessage } from "../../../redux/slices/notificationSlice";
import { Modal, Button, Spinner } from "react-bootstrap";
import {
  getAllManufacturerAction,
  getManufacturerById,
  editeManufacturerAction,
  deleteManufacturerAction,
} from "./getEditeManufacturer";
import AlertDeleteModal from "../../AlertDelete/AlertDeleteModal";
import axios from "axios";
import Axios from "axios";

export default function Variants() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const autoFocusRef = useRef(null);
  const fileInputRef = useRef(null);
  const location = useLocation();
  const rowData = [location.state?.rowData];
  const [allMfacturerData, setAllMfacturerData] = useState([]);
  const [editMaFacturerById, setEditMaFacturerById] = useState("");
  const [modalShow, setModalShow] = React.useState(false);
  const [editVarientModal, setEditVarientModal] = useState(false);
  const [manufacturerID, setManufacturerID] = useState(0);
  const [loading, setLoading] = useState(false);
  const [variantList, setVariantList] = useState([]);
  const [modalId, setModalId] = useState(0);
  const [variantFile, setVariantFile] = useState(null);

  //---- Delete Modal Variable -----//
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);

  const [modalRowsArr, setModalRowsArr] = useState([]);
  const [firstBlankField, setFirstBlankField] = useState(null);
  const [insertedId, setInsertedId] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [modalName, setModalName] = useState('');
  const [VarientName, setVarientName] = useState('');
  const [VarientId, setVarientId] = useState();

  const onAddNewRowsHandler = () => {
    setModalRowsArr((prevState) => [
      ...prevState,
      {
        id: new Date().getTime(),
        modalName: "",
        variants: [{ variantName: "" }],
      },
    ]);
  };

  const onAddNewVariantHandler = (modalIndex) => {
    setModalRowsArr((prevState) => {
      const updatedModalRowsArr = [...prevState];
      const modalRow = updatedModalRowsArr[modalIndex];
      modalRow.variants.push({ variantName: "" });
      return updatedModalRowsArr;
    });
  };

  const onRemoveModalHandler = (modalId) => {
    setModalRowsArr((prevState) =>
      prevState.filter((modal) => modal.id !== modalId)
    );
  };

  const onRemoveVariantHandler = (modalId, variantIndex) => {
    setModalRowsArr((prevState) => {
      const updatedModalRowsArr = [...prevState];
      const modalIndex = updatedModalRowsArr.findIndex(
        (modal) => modal.id === modalId
      );
      const modalRow = updatedModalRowsArr[modalIndex];
      modalRow.variants.splice(variantIndex, 1);
      return updatedModalRowsArr;
    });
  };

  const onModalNameChange = (event, modalIndex) => {
    setModalRowsArr((prevState) => {
      const updatedModalRowsArr = [...prevState];
      const modalRow = updatedModalRowsArr[modalIndex];
      modalRow.modalName = event.target.value;
      return updatedModalRowsArr;
    });
  };

  const onVariantNameChange = (event, modalIndex, variantIndex) => {
    setModalRowsArr((prevState) => {
      const updatedModalRowsArr = [...prevState];
      const modalRow = updatedModalRowsArr[modalIndex];
      const variantRow = modalRow.variants[variantIndex];
      variantRow.variantName = event.target.value;
      return updatedModalRowsArr;
    });
  };

  useEffect(() => {
    if (rowData) {
      rowData.map((val) => {
        setModalId(val.id);
        setManufacturerID(val.manufacturerId);
      });
    }
  }, [rowData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(variantFile);
    const manufacturerNameData = rowData;
    const manufacturerModalVarData = modalRowsArr;
    console.log(manufacturerModalVarData, "var");

    let firstBlankFieldIndex = null; // Index of the first blank field

    if (
      manufacturerNameData.length > 0 &&
      manufacturerModalVarData.length > 0
    ) {
      for (let i = 0; i < manufacturerModalVarData.length; i++) {
        const modalRow = manufacturerModalVarData[i];
        if (modalRow.modalName.trim() === "") {
          firstBlankFieldIndex = i;
          break;
        }
        for (let j = 0; j < modalRow.variants.length; j++) {
          const variantRow = modalRow.variants[j];
          if (variantRow.variantName.trim() === "") {
            firstBlankFieldIndex = i;
            break;
          }
        }
      }

      if (modalId) {
        // console.log(firstBlankFieldIndex, "blank");
        // All fields are filled, submit the data #manufacturerId
        // console.log(manufacturerNameData, "row");
        if(editVarientModal){
          const url = `${process.env.REACT_APP_NODE_URL}/api/master/updatVarient`;
          const config = {
            headers: {
              token: localStorage.getItem("rbacToken"),
            },
          };
          const requestData = {
            varient: VarientName,
            id: VarientId,
          };
          await axios.post(url, requestData, config).then((response) => {
            if (response.data && response.data.isSuccess) {
              dispatch(setShowMessage("Data Successfully Updated."));
              setEditVarientModal(false);
              handleClose();
              getVariantList();
            }
          });
        }else{
        console.log(manufacturerModalVarData[0].variants, "varirantlist");
        const variantFile = manufacturerModalVarData[0].variants;

        const url = `${process.env.REACT_APP_NODE_URL}/api/master/addvariant`;
        const config = {
          headers: {
            token: localStorage.getItem("rbacToken"),
          },
        };
        const formData = new FormData();
        const variantsArray = [];
        for (let i = 0; i < variantFile.length; i++) {
          const files = variantFile[i].variantFile;
          const variant = variantFile[i].variantName;
          variantsArray.push(variant);
          // formData.append("variantFiles", files);
        }

        formData.append("variantFiles", JSON.stringify(insertedId));
        formData.append("variants", JSON.stringify(variantsArray));
        formData.append("modalid", modalId);
        formData.append("manufacturerId", manufacturerID);

        await axios.post(url, formData, config).then((response) => {
          if (response.data && response.data.isSuccess) {
            dispatch(setShowMessage("Data Successfully Saved."));
            handleClose();
            getVariantList();
          }
        });
      }
      } else {
        // Set focus on the first blank field
        setFirstBlankField(firstBlankFieldIndex);
      }
    } else {
      dispatch(setShowMessage("All Field Must be Required."));
    }
  };

  const redirectModal = () => {
    navigate(-1);
  };

  const ErrorMsg = () => {
    dispatch(setShowMessage("All Field Must be Required."));
  };
  useEffect(() => {
    if (firstBlankField !== null && autoFocusRef.current) {
      autoFocusRef.current.focus();
    }
  }, [firstBlankField]);

  useEffect(() => {
    onAddNewRowsHandler();
  }, []);

  useEffect(() => {
    const uploadLogo = async () => {
      if (variantFile && variantFile.name != null) {
        const url = `${process.env.REACT_APP_NODE_URL}/api/employees/upload-document`;
        const config = {
          headers: {
            token: localStorage.getItem("rbacToken"),
          },
        };
        const formData = new FormData();
        formData.append('document', variantFile);
        try {
          const response = await Axios.post(url, formData, config);
          if (response.data) {
            setInsertedId([...insertedId, response.data.result.insertId]);
            console.log(response.data.result, "sdasdasdasdas")
          }
        } catch (error) {
          console.error("Error uploading document:", error);
        }
      }
    };

    uploadLogo();
  }, [variantFile]);

  const getVariantList = async () => {
    console.log(modalId, "get");
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/getvariant/${modalId}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };

    try {
      setLoading(true);
      const response = await axios.get(url, config);
      if (response.data && response.data.isSuccess) {
        console.log(response.data.result);
        setVariantList(response.data.result);
      } else {
        console.log(response.data.result);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (manufacturerID !== 0) {
      getVariantList();
    }
  }, [manufacturerID]);

  const handleShow = () => {
    setModalShow(true);
  };
  const handleClose = () => {
    setModalShow(false);
  };

  const handleUpdateModal = async (e) => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/updatemodal`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    const requestData = {
      modal: modalName,
      id: modalId,
    };
    await axios.post(url, requestData, config).then((response) => {
      if (response.data && response.data.isSuccess) {
        dispatch(setShowMessage("Data Successfully Updated."));
        setEditModal(false);
        redirectModal();
      }
    });
  }

  const editeManufactureModal = () => {
    setEditModal(true);
    rowData.map((val) => {
      setModalName(val.modalName);
    });
  }
  const HandleediteVarient = (row) => {
    setVarientName(row.variantName);
    setVarientId(row.id)
    console.log(id, "varient id@@@@@@@@@@@@@@@@");
    setEditVarientModal(true);
    handleShow();
  }
  const deleteModalAlert = () => {
    setDisplayConfirmationModal(true);
    setType("modal_delete");
    setId(modalId);
    setDeleteMessage(
      `Are You Sure You Want To Delete The Modal '${rowData.map(
        (val) => val.modalName
      )}'?`
    );
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const submitDelete = async () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/deletemodal`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    const requestData = {
      modalid: modalId,
      manufacturerId: manufacturerID,
    };

    await axios.post(url, requestData, config).then((response) => {
      if (response.data && response.data.isSuccess) {
        console.log(response.data.result);
        hideConfirmationModal();
        redirectModal();
        dispatch(setShowMessage("Modal Sucessfully Deleted."));
      }
    });
  };
  const handleFileChange = (e, modalIndex, variantIndex) => {
    const files = e.target.files[0];
    setVariantFile(files)
  };
  return (
    <>
      <div>
        <div className="card">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-10 col-md-10 col-sm-10">
                <div className="d-flex align-items-center">
                  <li className="d-flex align-items-center p-2">
                    <main className="d-flex align-items-center">
                      <div className="myBtnRight">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          className="bi bi-chevron-double-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"
                          />
                          <path
                            fill-rule="evenodd"
                            d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"
                          />
                        </svg>
                      </div>
                      <span className="ms-2">
                        {rowData &&
                          rowData.length > 0 &&
                          rowData.map((val) => val.modalName)}
                      </span>
                    </main>
                  </li>
                </div>
              </div>
              <div className="col-2 col-md-2 col-sm-2">
                <div className="d-flex justify-content-end">
                  <button
                    className="myActionBtn m-1"
                    onClick={() => {
                      deleteModalAlert();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-trash3"
                      viewBox="0 0 16 16"
                    >
                      <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                    </svg>
                  </button>
                  <button
                    className="myActionBtn m-1"
                    onClick={() => {
                      editeManufactureModal();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      className="bi bi-pencil-square"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                      <path
                        fillRule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                      />
                    </svg>
                  </button>
                  <Button
                    className="rounded-pill mx-1"
                    variant="btn btn-warning"
                    onClick={() => redirectModal()}
                  >
                    BACK
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="d-flex  flex-column col-12 col-lg-5 mt-2">
              <label className="myLabel mx-4" htmlFor="email">
                Modal Name
              </label>
              {editModal ?
                <input
                  value={modalName}
                  className="myInput mx-4"
                  name="modalname"
                  onChange={(e) => setModalName(e.target.value)}
                /> :
                <input
                  disabled
                  className="myInput mx-4"
                  name=""
                  value={
                    rowData &&
                    rowData.length > 0 &&
                    rowData.map((val) => val.modalName)
                  }
                />}

            </div>
            {editModal &&
              <div className="d-flex  flex-column col-12 col-lg-5 mt-4">
                <Button
                  className="rounded-pill mx-auto"
                  variant="btn btn-secondary"
                  onClick={handleUpdateModal}
                >
                  Update Modal
                </Button>
              </div>
            }
          </div>

          <section>
            <hr />
            <div className="mx-4 m-0">
              <div className="d-flex align-items-end justify-content-between">
                <h6 className="fw-bold myH9 m-0 d-flex align-items-start justify-content-start">
                  Variant List
                </h6>

                <div
                  onClick={handleShow}
                  className="d-flex align-items-center"
                  type="button"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-plus-circle"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                  </svg>
                  <h6 className="m-0 ps-1">Add Variant</h6>
                </div>
              </div>
            </div>
            <div className="mx-4 m-0"></div>
            <hr />
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spinner style={{ color: "rgb(132, 211, 227)" }} />
              </div>
            ) : (
              variantList.map((row) => {
                return (
                  <div className="master">
                    <main className="my-0">
                      <ul className="row m-0 px-2">
                        <li className="col-12 d-flex justify-content-between p-2">
                          <main
                            className="d-flex align-items-center"
                          >
                            <div className="myBtnRight">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                className="bi bi-chevron-double-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"
                                />
                                <path
                                  fill-rule="evenodd"
                                  d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"
                                />
                              </svg>
                            </div>
                            <span className="ms-2">{row.variantName}</span>
                          </main>
                          <button
                            className="myActionBtn m-1"
                            onClick={() => {
                              HandleediteVarient(row);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              className="bi bi-pencil-square"
                              viewBox="0 0 16 16"
                            >
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                              <path
                                fillRule="evenodd"
                                d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                              />
                            </svg>
                          </button>
                        </li>
                      </ul>
                    </main>
                  </div>
                );
              })
            )}
          </section>
        </div>
      </div >
      <AlertDeleteModal
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={id}
        message={deleteMessage}
      />
      <Modal show={modalShow} onHide={handleClose}>
        <Modal.Header closeButton>
          <h5 className="modal-title" id="districtModalLabel">
            {editVarientModal ? 'UPDATE VARIANT' : 'ADD VARIANT'}
          </h5>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="my-3  d-flex align-items-end justify-content-end">
              <div className="d-flex align-items-center" type="button">
                <h6 className="m-0 ps-1"></h6>
              </div>
            </div>
            <div className="card">
              <div className="card-header">
                <div className="d-flex">
                  <label className="form-label">Modal Name:</label>
                  <p className="px-4">
                    {rowData &&
                      rowData.length > 0 &&
                      rowData.map((val) => val.modalName)}
                  </p>
                </div>
              </div>
              <div className="card-body">
                {modalRowsArr.length > 0 &&
                  modalRowsArr.map((modalRow, modalIndex) => (
                    <div className="row" key={`ModaleNumber_${modalIndex}`}>
                      <div className="col-12">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label"
                        >
                          Variant Name *
                        </label>
                        {editVarientModal ?
                          <>
                            <input
                              value={VarientName}
                              className="myInput mx-4"
                              name="VarientName"
                              onChange={(e) => setVarientName(e.target.value)}
                            />
                          </> :
                          <>
                            {modalRow.variants.map((variantRow, variantIndex) => (
                              <div
                                className="row mb-2"
                                key={`VariantNumber_${variantIndex}`}
                              >
                                <div className="col-10">
                                  <input
                                    type="text"
                                    className={`form-control ${firstBlankField === modalIndex
                                      ? "is-invalid"
                                      : "was-validated"
                                      }`}
                                    id={`variantName_${modalIndex}_${variantIndex}`}
                                    name={`variantName_${modalIndex}_${variantIndex}`}
                                    value={variantRow.variantName}
                                    onChange={(event) =>
                                      onVariantNameChange(
                                        event,
                                        modalIndex,
                                        variantIndex
                                      )
                                    }
                                    ref={
                                      firstBlankField === modalIndex
                                        ? autoFocusRef
                                        : null
                                    }
                                  />
                                  <div className="mt-2">
                                    <label
                                      htmlFor={`variantFile_${modalIndex}_${variantIndex}`}
                                      className="variant-label"
                                    >
                                      Attach File *
                                    </label>
                                    <input
                                      type="file"
                                      name={`variantfile_${modalIndex}_${variantIndex}`}
                                      id={`variantFile_${modalIndex}_${variantIndex}`}
                                      className="variant-control"
                                      multiple // Allow multiple file selection
                                      onChange={(e) => {
                                        handleFileChange(
                                          e,
                                          modalIndex,
                                          variantIndex
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-2 mx-auto my-auto">
                                  {modalRow.variants.length === variantIndex + 1 ? (
                                    <Button
                                      className="btn-lg"
                                      variant="primary rounded-circle"
                                      onClick={() =>
                                        onAddNewVariantHandler(modalIndex)
                                      }
                                    >
                                      +
                                    </Button>
                                  ) : (
                                    <Button
                                      className="btn-lg"
                                      variant="danger rounded-circle"
                                      onClick={() =>
                                        onRemoveVariantHandler(
                                          modalRow.id,
                                          variantIndex
                                        )
                                      }
                                    >
                                      -
                                    </Button>
                                  )}
                                </div>
                              </div>
                            ))}
                          </>
                        }
                      </div>
                    </div>
                  ))}
              </div>
              <div className="card-footer">
                <div className="d-flex align-items-center justify-content-center">
                  <Button
                    variant="btn btn-warning mx-1"
                    onClick={() => {
                      redirectModal();
                    }}
                  > CANCEL
                  </Button>
                  <Button variant="btn btn-success mx-1" onClick={handleSubmit}>
                    {editVarientModal ? 'UPDATE' : 'SAVE'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {" "}
            Close{" "}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
